import { render } from "./UploadButton.vue?vue&type=template&id=398b6ba0"
import script from "./UploadButton.vue?vue&type=script&lang=js"
export * from "./UploadButton.vue?vue&type=script&lang=js"
script.render = render

export default script